import * as React from 'react';
import { IItemCardProps } from 'models/itemcard';
import { IUserCard } from 'models/user/usercard';
import renderIcon from 'helpers/renderIcon';
import { INodeDto } from 'models/common';
import { IOfficeMember } from 'models/shop/members';
require('./style.scss');
import { thumbUrl } from 'helpers/common';

interface IProps extends IItemCardProps {
	item: IOfficeMember; // | INodeDto;

	customProps: {
		readOnly?: boolean;
		editMember: (staffMemberData: IUserCard | INodeDto) => void;
		removeMember: () => void;
		staffMemberOverview?: (staffMemberId: string, staffMemberData: IUserCard | INodeDto) => void;
		hideEditButton?: boolean;
		customClassName?: string;
	};
}

class StaffPreviewItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		// DO NOT FORGET TO BIND FUNCTIONS TO THIS
	}

	public render() {
		const { item: staffMember, customProps } = this.props;
		const { removeMember, readOnly, editMember, staffMemberOverview, hideEditButton } = customProps;
		const hasPicture = !!staffMember.picture;
		const picture = hasPicture ? (
			<img
				src={thumbUrl(staffMember.picture, 'large')}
				alt={`${staffMember.name}'s profile picture`}
				className="black-white"
			/>
		) : (
			renderIcon('smile_happy')
		);
		return (
			<div
				className={`StaffPreviewItemCard 
					${hasPicture ? '' : 'default-pfp'}
					${customProps?.customClassName ? customProps.customClassName : ''}
				`}
			>
				<div className="control-buttons">
					{!hideEditButton && readOnly && (
						<button className="iconBtn round" type="button" onClick={() => editMember(staffMember)}>
							{renderIcon('edit')}
						</button>
					)}
					{!hideEditButton && !readOnly && (
						<button className="iconBtn round" type="button" onClick={() => removeMember()}>
							{renderIcon('delete_2')}
						</button>
					)}
				</div>
				<div className="photo-container">{picture}</div>
				<div
					className="card-content d-flex flex-column justify-content-end"
					onClick={() => (staffMemberOverview ? staffMemberOverview(staffMember.id, staffMember) : null)}
				>
					<h4>{staffMember.name?.length > 37 ? staffMember.name.substring(0, 37) + '...' : staffMember.name}</h4>
					<h3>
						{staffMember.jobTitle?.length > 17 ? staffMember.jobTitle.substring(0, 17) + '...' : staffMember.jobTitle}
					</h3>
					{staffMember.description && <p className="staff-member-about">{staffMember.description}</p>}
				</div>
			</div>
		);
	}
}

export { StaffPreviewItemCard };
